import { render } from "./AreaMultiple.vue?vue&type=template&id=6d0e84c1"
import script from "./AreaMultiple.vue?vue&type=script&lang=js"
export * from "./AreaMultiple.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__